import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import { useCrmObjectType } from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';

/**
 * This hook is meant to be used by host apps.
 * Exposing a getter and setter for expandable row objects
 */
export default function useExpandCollapseRow() {
  "use memo";

  const $ = _c(11);
  const {
    expandableObjectIds,
    onSetExpandableObjectIds
  } = useCrmObjectType();
  let t0;
  if ($[0] !== onSetExpandableObjectIds) {
    t0 = () => onSetExpandableObjectIds([]);
    $[0] = onSetExpandableObjectIds;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const collapseAll = t0;
  let t1;
  if ($[2] !== onSetExpandableObjectIds) {
    t1 = objectId => {
      onSetExpandableObjectIds(prevValue => {
        if (prevValue.includes(objectId)) {
          return prevValue;
        }
        return [...prevValue, objectId];
      });
    };
    $[2] = onSetExpandableObjectIds;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const expandRow = t1;
  let t2;
  if ($[4] !== onSetExpandableObjectIds) {
    t2 = objectId_0 => {
      onSetExpandableObjectIds(prevValue_0 => prevValue_0.filter(id => id !== objectId_0));
    };
    $[4] = onSetExpandableObjectIds;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const collapseRow = t2;
  let t3;
  if ($[6] !== collapseAll || $[7] !== collapseRow || $[8] !== expandRow || $[9] !== expandableObjectIds) {
    t3 = {
      collapseAll,
      collapseRow,
      expandableObjectIds,
      expandRow
    };
    $[6] = collapseAll;
    $[7] = collapseRow;
    $[8] = expandRow;
    $[9] = expandableObjectIds;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}